import React from 'react';
import '../Estilos/NivelCard.css';
import TextInput from './TextInput';
import Espaçador from './Espaçador';
import SelectUserInput from './SelectUserInput';

export default function NivelCard(props) {
  const {
    titulo,
    expanded,
    menu_clicked,
    expiryTime,
    notifyTime,
    responsible,
    users,
    changes,
    largura,
    disabled,
    erro = null,
    erroTexto = '',
  } = props;

  return (
    <div className="card_level_view" style={{ width: '100%' }}>
      <div className="level_menu" onClick={menu_clicked}>
        <h3>{titulo}</h3>
        <img src={require('../Icones/setinhaSelect.svg').default} alt="" />
      </div>

      <div className={`level_options ${expanded ? 'expanded' : ''}`}>
        <div className="hourView">
          <TextInput
            titulo="Notificação (min)"
            padrao={notifyTime}
            placeholder="Notificação (min)"
            tipo="number"
            largura="45%"
            onUpdate={(txt) => changes('notifyTime', txt)}
            minValue={0}
          />
          <Espaçador espaço="10px" />
          <TextInput
            titulo="Resolução (min)"
            padrao={expiryTime}
            placeholder="Resolução (min)"
            tipo="number"
            largura="45%"
            onUpdate={(txt) => changes('expiryTime', txt)}
            minValue={0}
          />
          <Espaçador espaço="10px" />
        </div>
        <div className="responsible" style={{ width: '95%' }}>
          <SelectUserInput
            titulo="Responsável"
            itens={users ? users : [{ label: 'Selecione', value: null }]}
            padrao={responsible ? responsible : []}
            largura="100%"
            clicado={(selectedUsers) => changes('user', selectedUsers)}
            disabled={disabled}
          />
        </div>
        {erro && (
          <div
            style={{
              height: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              paddingTop: 8,
            }}
          >
            <img src={require('../Icones/block.svg').default} alt="block" />
            <h4
              style={{
                color: 'red',
                fontSize: 12,
                padding: 0,
                margin: 0,
                verticalAlign: 'center',
                paddingLeft: 8,
                fontFamily: 'montserrat',
                fontWeight: 500,
              }}
            >
              {erroTexto}
            </h4>
          </div>
        )}
      </div>
    </div>
  );
}
